import { GetterTree } from 'vuex'
import CenterState from './states'
import { State } from '@/store/store'
import * as _ from 'lodash'

const getters: GetterTree<CenterState, State> = {
  headers: (state) => {
    return state.list.column
  },
  itemLists: (state) => {
    return state.list.result
  },
  filterLists: (state) => {
    return state.list.defaultFilter
  },
  pagination: (state) => {
    const paginationLists = {
      itemCount: state.list.itemCount,
      page: state.list.page,
      pageCount: state.list.pageCount,
    }
    return paginationLists
  },
}

export default getters
